import { Fragment, useEffect, useLayoutEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { useUserState } from "../../Contexts/UserContext";

import HeroBannerSec from "./heroBannerSec/HeroBannerSec";
import TopPropertiesSec from "./topPropertiesSec/TopPropertiesSec";
import WhyChoose from "./whychoosesec/WhyChoose";
import PropertyGallery from "./propertygallery/PropertyGallery";
import TestimonialsSec from "./testimonialsSec/TestimonialsSec";
import AppPromo from "./apppromo/AppPromo";
import TrustedPartnerSec from "./trustedPartnerSec/TrustedPartnerSec";

const Home = () => {
  const { user } = useUserState();
  const navigate = useNavigate();
  const location = useLocation();

  useLayoutEffect(() => {
    if (
      user?.currentRole === "cleaning_company" ||
      user?.currentRole === "furniture_company" ||
      user?.currentRole === "home_owner" ||
      user?.currentRole === "property_manager"
    ) {
      navigate(`/user_dash/${user?.currentRole}`);
    } else {
      // navigate("/");
    }
  }, [user]);

  useEffect(() => {
    if (
      location.hash === "#trusted-partners-sec" ||
      location.state?.scrollTo === "trusted-partners-sec"
    ) {
      setTimeout(() => {
        const element = document.getElementById("trusted-partners-sec");
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    } else {
      window.scrollTo({
        top: 0,
        behavior: "instant",
      });
    }
  }, [location.hash, location.state]);

  return (
    <Fragment>
      <HeroBannerSec />
      <div className="top-property-sec">

        <TopPropertiesSec />
      </div>
      <WhyChoose />
      <PropertyGallery />
      <div className="testimonials-sec">
        <TestimonialsSec />
        <TrustedPartnerSec />
      </div>
      <AppPromo />
    </Fragment>
  );
};

export default Home;
